<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      fill-rule="evenodd"
      d="M14.9 2.3A1 1 0 1 0 13.4 4l1 1h-3.1a1 1 0 0 0-.7.7v7.1a1 1 0 0 0 .7.7h4V7a.9.9 0 1 1 1.9 0v6.4h4a1 1 0 0 0 .8-.7V5.6a1 1 0 0 0-.7-.7h-3.1l1-1a1 1 0 0 0-1.5-1.6l-1.4 1.4zM4.6 12H2v5.7l2.6 2.6a6 6 0 0 0 4 1.7H17a2.1 2.1 0 1 0 0-4.3h-4A3 3 0 0 1 8 19l-2-2a.9.9 0 1 1 1.2-1.3l2 2a1.2 1.2 0 0 0 2-1.6l-2.5-2.4a6 6 0 0 0-4-1.7"
      clip-rule="evenodd"
    />
  </svg>
</template>
